import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import CustomDonations from './CustomDonations';
import { Elements } from '@stripe/react-stripe-js';

const CustomDonationsIndex = ({ projectsLists, defaultSelected }) => {
  const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PUBLISHABLE_KEY);

  return (
    <Elements stripe={stripePromise}>
      <div className="wrapper wrapper-xs">
        <CustomDonations projectsLists={projectsLists} defaultSelected={defaultSelected} />
      </div>
    </Elements>
  );
};

export default CustomDonationsIndex;
